var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"即時資訊"}},[_c('b-table',{attrs:{"striped":"","hover":"","fields":_vm.fields,"items":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }